import { doGet, doPost } from 'circe/Http/saga';
import { shippingClient } from 'domain/HttpClients';

export const fetch = (orderId) => shippingClient.Get(`/api/shipments/order/${orderId}`).send();

export const fetchPdf = (orderId) => shippingClient
  .Get('/api/shipments/get-shipments-label-link')
  .withParams({ 'order-id': orderId, 'template-name': 'masheed-waybill' })
  .send();

export const generateOTP = (shipmentId, headers) => doPost(
  '/api/confirmation/otp/generate',
  {
    objectId: shipmentId,
    otpType: 'ALPHANUMERIC',
    otpDeliveryType: ['WEB'],
  },
  headers,
  {},
  SHIPPING_EDGE,
  false,
  true,
);

export const assign = (payload, headers) => doPost(
  '/api/masheed/single-forecast-sales-order/assign-shipments',
  payload,
  headers,
  {},
  OPERATIONS_EDGE,
  false,
  true,
);

export const cancel = (shipmentId, headers) => doPost(
  `${SHIPPING_EDGE}/api/shipments/${shipmentId}/cancelRequest`,
  {},
  headers,
  {},
  null,
  false,
  true,
);

export const cancelShipments = (shipmentIds, reason) => shippingClient
  .Post('/api/shipments/cancel')
  .withData(shipmentIds, reason)
  .send();

export const updateWaybillNotes = (waybill, notes) => shippingClient
  .Post(`/api/waybills/${waybill}/updates`)
  .withData({ notes })
  .send();

export const cancelConfirm = (invoiceId, shipmentId, headers) => doPost(
  `${SHIPPING_EDGE}/api/shipments/${shipmentId}/cancelConfirm`,
  {},
  headers,
  {
    params: {
      invoice: invoiceId,
    },
  },
  null,
  false,
  true,
);
